module.exports = __webpack_public_path__ + "static/media/cloud-1.56c04f4d.png";